var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CharacteristicEdit", {
    ref: "edit",
    attrs: {
      "title-formats": {
        default: "Welche Bereiche in %characteristicLabel%?",
        level: {
          1: "Welche Tätigkeiten und Aufgaben möchtest du?"
        }
      },
      "with-keyword": "",
      "keyword-placeholder":
        "Tätigkeit, Aufgabenbereich eingeben (mind. 3 Zeichen)",
      "characteristic-items": _vm.characteristicItems,
      "characteristic-type": _vm.meta.functionType,
      "supplements-config": {
        nothingAllowed: true,
        types: _vm.supplementTypes
      },
      "nothing-allowed": {
        overall: _vm.nothingAllowedOverall,
        minimumLevel: 2
      },
      "selected-items-config": {
        noChildrenAppendix: "Alle Tätigkeiten möglich"
      },
      "search-config": { catalog: _vm.meta.searchCatalogFunction },
      "open-fan-label": "Tätigkeiten auswählen",
      "label-type": "application",
      "with-edit-button": _vm.withEditButton
    },
    on: {
      input: function($event) {
        return _vm.$emit("input", $event)
      }
    },
    model: {
      value: _vm.functions,
      callback: function($$v) {
        _vm.functions = $$v
      },
      expression: "functions"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }